/**
 * TEXTOS DA NOVA EXPERIÊNCIA (CERES-UX-001) — português.
 *
 * Num módulo próprio para que a missão não reescreva o dicionário inteiro: as
 * chaves são espalhadas em `PT` (i18n.ts) e, em inglês, em `EN` (i18n.en.ts,
 * a partir de `i18n.ux.en.ts`). O teste de paridade continua valendo sobre o
 * dicionário final — chave nova sem tradução reprova.
 */

export const UX_PT = {
  // Navegação por jornada
  'ux.nav.hoje': 'Hoje',
  'ux.nav.hojeAjuda': 'O que exige ação agora',
  'ux.nav.preVendas': 'Pré-vendas',
  'ux.nav.preVendasAjuda': 'Da captura à entrega',
  'ux.nav.negocios': 'Negócios',
  'ux.nav.negociosAjuda': 'Da entrada ao fechamento',
  'ux.nav.conversas': 'Conversas',
  'ux.nav.conversasAjuda': 'WhatsApp, e-mail e reuniões',
  'ux.nav.relacionamentos': 'Relacionamentos',
  'ux.nav.relacionamentosAjuda': 'Empresas, pessoas e histórico',
  'ux.nav.mais': 'Mais',
  'ux.nav.maisAjuda': 'Módulos, gestão e configuração',
  'ux.nav.navegacaoInferior': 'Jornadas',

  // Busca global
  'ux.busca.rotulo': 'Buscar empresa, pessoa ou negócio',
  'ux.busca.placeholder': 'Buscar empresa, pessoa ou negócio',
  'ux.busca.tipoEmpresa': 'Empresa',
  'ux.busca.tipoPessoa': 'Pessoa',
  'ux.busca.tipoNegocio': 'Negócio',
  'ux.busca.nada': 'Nada encontrado com esse termo no que você pode ver.',
  'ux.busca.digite': 'Digite ao menos duas letras.',
  'ux.busca.erro': 'A busca não respondeu. Tente de novo em instantes.',

  // Mais
  'ux.mais.titulo': 'Mais',
  'ux.mais.subtitulo':
    'Módulos habilitados, registros, gestão e configuração — fora da rotina, sem sair do alcance.',
  'ux.mais.grupoModulos': 'Módulos habilitados',
  'ux.mais.grupoRegistros': 'Operação comercial',
  'ux.mais.grupoGestao': 'Gestão',
  'ux.mais.grupoConfiguracao': 'Configuração e ajuda',
  'ux.mais.csAjuda': 'Clientes, saúde e expansão',
  'ux.mais.parceirosAjuda': 'Canal e indicações',
  'ux.mais.reservasAjuda': 'Regras de propriedade de conta',
  'ux.mais.comissoesAjuda': 'Cálculo e acompanhamento',
  'ux.mais.atividadesAjuda': 'Todas as tarefas, ligações e reuniões',
  'ux.mais.caixaAjuda': 'O que saiu, falhou ou chegou',
  'ux.mais.reunioesAjuda': 'Registros, itens e coaching',
  'ux.mais.propostasAjuda': 'Todas as propostas registradas',
  'ux.mais.contratosAjuda': 'Minutas e contratos',
  'ux.mais.cadenciasAjuda': 'Sequências de contato',
  'ux.mais.agentesAjuda': 'Agentes de IA do CRM',
  'ux.mais.receitaAjuda': 'Previsão e realizado',
  'ux.mais.relatoriosAjuda': 'Análises comerciais',
  'ux.mais.aprovacoesAjuda': 'Alçadas pendentes',
  'ux.mais.catalogoAjuda': 'Ofertas, método e biblioteca',
  'ux.mais.administracao': 'Administração',
  'ux.mais.administracaoAjuda': 'Equipe, regras, integrações e auditoria',
  'ux.mais.ajudaAjuda': 'Orientação por tela e por assunto',

  // Hoje e estados comuns
  'ux.estado.semPermissaoTitulo': 'Seu perfil não tem acesso a esta área',
  'ux.estado.semPermissaoTexto':
    'Se você precisa dela, fale com quem administra os acessos deste CRM.',
  'ux.estado.parcialTitulo': 'Parte desta tela não está disponível.',
  'ux.estado.parcialTexto': 'Fora do seu perfil ou do plano:',
  'ux.estado.desatualizado': 'Estes dados são de',
  'ux.estado.recarregar': 'Atualizar agora',
  'ux.nba.rotulo': 'Próxima melhor ação',
  'ux.comum.dia': 'dia',
  'ux.comum.dias': 'dias',
  'ux.hoje.titulo': 'O que precisa acontecer hoje',
  'ux.hoje.subtitulo': 'A fila começa pela decisão; os indicadores ficam em Resultados.',
  'ux.hoje.deQuem': 'De quem é a fila',
  'ux.hoje.minhaFila': 'Minha fila',
  'ux.hoje.equipe': 'Equipe',
  'ux.hoje.visao': 'Visão',
  'ux.hoje.trabalho': 'Trabalho',
  'ux.hoje.resultados': 'Resultados',
  'ux.hoje.carregando': 'Carregando a fila de hoje',
  'ux.hoje.filaTitulo': 'Fila do dia',
  'ux.hoje.filaDescricao':
    'Ordenada por compromisso, atraso e impacto — o motivo está em cada item.',
  'ux.hoje.vazioTitulo': 'Nada exige ação agora',
  'ux.hoje.vazioTexto':
    'Nenhuma atividade vencida ou de hoje, nenhum negócio seu parado ou sem próximo passo e nenhuma mensagem esperando resposta.',
  'ux.hoje.vazioTextoEquipe':
    'Nada vencido, parado ou esperando resposta no que você enxerga da equipe.',
  'ux.hoje.vazioAcao': 'Revisar os negócios',
  'ux.hoje.filaEmDia': 'A fila está em dia.',
  'ux.hoje.proximo': 'Próximo:',
  'ux.hoje.depoisDisso': 'Depois disso:',
  'ux.hoje.porQueAgora': 'Por que agora',
  'ux.hoje.posicao': 'Posição',
  'ux.hoje.pontos': 'pontos',
  'ux.hoje.base': 'base',
  'ux.hoje.atraso': 'atraso',
  'ux.hoje.impacto': 'impacto',
  'ux.hoje.empresa': 'Empresa',
  'ux.hoje.pessoa': 'Pessoa',
  'ux.hoje.negocio': 'Negócio',
  'ux.hoje.prazo': 'Prazo',
  'ux.hoje.responsavel': 'Responsável',
  'ux.hoje.semResponsavel': 'Sem responsável',
  'ux.hoje.valor': 'Valor',
  'ux.hoje.ha': 'há',
  'ux.hoje.esperandoHa': 'esperando há',
  'ux.hoje.naEtapa': 'na etapa',
  'ux.hoje.sla': 'SLA',
  'ux.hoje.tom.agora': 'Agora',
  'ux.hoje.tom.hoje': 'Hoje',
  'ux.hoje.tom.planejar': 'Planejar',
  'ux.hoje.concluir': 'Concluir',
  'ux.hoje.reagendar': 'Reagendar',
  'ux.hoje.novoPrazo': 'Novo prazo',
  'ux.hoje.salvar': 'Salvar',
  'ux.hoje.proximoPasso': 'Próximo passo',
  'ux.hoje.proximoPassoExemplo': 'Ex.: ligar para o decisor e confirmar o escopo',
  'ux.hoje.quando': 'Quando',
  'ux.hoje.salvarPasso': 'Registrar próximo passo',
  'ux.hoje.novaPrevisao': 'Nova previsão de fechamento',
  'ux.hoje.salvarPrevisao': 'Atualizar previsão',
  'ux.hoje.abrirContexto': 'Abrir o contexto completo',
  'ux.hoje.feitoConcluida': 'Atividade concluída e registrada.',
  'ux.hoje.feitoReagendada': 'Atividade reagendada.',
  'ux.hoje.feitoNegocio': 'Negócio atualizado.',
  'ux.hoje.comoOrdena': 'Como esta fila é ordenada',
  'ux.hoje.formula':
    'Cada item soma a base da regra que o trouxe, um ponto por dia de atraso e o impacto pela faixa de valor. Um registro aparece uma vez, pela regra mais forte; as outras viram motivo adicional.',
  'ux.hoje.formulaAtraso': 'Atraso: um ponto por dia, até',
  'ux.hoje.formulaImpacto': 'Impacto:',
  'ux.hoje.formulaParada': 'Negócio parado: além do SLA da etapa ou, sem SLA, de',
  'ux.hoje.jornadas': 'Jornada do dia',
  'ux.hoje.semear': 'Semear',
  'ux.hoje.semearTexto': 'em pré-vendas pedem ação',
  'ux.hoje.cultivar': 'Cultivar',
  'ux.hoje.cultivarTexto': 'pedem continuidade',
  'ux.hoje.colher': 'Colher',
  'ux.hoje.colherTexto': 'perto da decisão',
  'ux.hoje.regra.ATIVIDADE_VENCIDA': 'Atividade vencida',
  'ux.hoje.regra.COMPROMISSO_DE_HOJE': 'Compromisso marcado para hoje',
  'ux.hoje.regra.PROXIMO_PASSO_VENCIDO': 'Próximo passo vencido',
  'ux.hoje.regra.MENSAGEM_SEM_RESPOSTA': 'Cliente aguardando resposta',
  'ux.hoje.regra.FECHAMENTO_VENCIDO': 'Previsão de fechamento vencida',
  'ux.hoje.regra.ATIVIDADE_DE_HOJE': 'Tarefa com prazo hoje',
  'ux.hoje.regra.PROPOSTA_VENCENDO': 'Validade da proposta vencendo',
  'ux.hoje.regra.FECHAMENTO_PROXIMO': 'Fechamento previsto para esta semana',
  'ux.hoje.regra.OPORTUNIDADE_PARADA': 'Negócio parado',
  // CERES-PRE-001 — atenção operacional da pré-venda
  'ux.hoje.regra.PRE_VENDA_HOJE': 'Ação de pré-venda prevista para hoje',
  'ux.hoje.regra.PRE_VENDA_SEM_PROXIMA': 'Pré-venda sem próxima ação',
  'ux.hoje.regra.PRE_VENDA_PARADA': 'Pré-venda parada nesta etapa',
  'ux.hoje.pv.etapa': 'Etapa',
  'ux.hoje.pv.tempoNaEtapa': 'Tempo na etapa',
  'ux.hoje.pv.proximaAcao': 'Próxima ação',
  'ux.hoje.pv.semProximaAcao': 'Nenhuma ação com data',
  'ux.hoje.pv.motivos': 'Motivos de atenção',
  'ux.hoje.pv.limite': 'limite',
  'ux.pv.atencao.ACAO_ATRASADA': 'Atrasada',
  'ux.pv.atencao.ACAO_HOJE': 'Hoje',
  'ux.pv.atencao.SEM_PROXIMA_ACAO': 'Sem próxima ação',
  'ux.pv.atencao.CICLO_PARADO': 'Parada há',
  'ux.pv.atencao.nutricaoVencida': 'Nutrição terminou',
  'ux.pv.atencao.motivo.ACAO_ATRASADA': 'Atividade vencida há',
  'ux.pv.atencao.motivo.ACAO_HOJE': 'Ação prevista para hoje',
  'ux.pv.atencao.motivo.SEM_PROXIMA_ACAO': 'Sem próxima ação',
  'ux.pv.atencao.motivo.CICLO_PARADO': 'Parada nesta etapa há',
  'ux.pv.atencao.motivo.nutricaoVencida':
    'A nutrição terminou: revise se retoma, prorroga ou descarta',
  'ux.pv.atencao.acao.REGISTRAR_INTERACAO': 'Registre uma interação',
  'ux.pv.atencao.acao.DEFINIR_PROXIMA_ACAO': 'Defina a próxima ação',
  'ux.pv.atencao.acao.AGENDAR_DATA': 'Agende a data',
  'ux.pv.atencao.acao.EXECUTAR_DECISAO': 'Execute a decisão desta etapa',
  'ux.pv.atencao.acao.REVISAR_NUTRICAO': 'Revise a nutrição',
  'ux.pv.atencao.indicadorSemProxima': 'pré-vendas sem próxima ação',
  'ux.pv.atencao.indicadorParados': 'pré-vendas paradas',
  'ux.pv.atencao.indicadorAtrasadas': 'pré-vendas com ação atrasada',
  'ux.pv.atencao.indicadoresSobrepoem':
    'Contadores de condição: uma mesma pré-venda pode aparecer em mais de um.',
  'ux.pv.atencao.filtroParados': 'Paradas',
  'ux.pv.atencao.aplicarFiltro': 'Filtrar a Carteira por esta condição',
  'ux.hoje.regra.PRE_VENDA_ATRASADA': 'Ação de pré-venda atrasada',
  'ux.hoje.regra.REVISAR_CONGELAMENTO': 'Congelamento chegou à revisão',
  'ux.hoje.regra.SEM_PROXIMO_PASSO': 'Negócio sem próximo passo',
  'ux.hoje.acao.CONCLUIR_ATIVIDADE': 'Executar a atividade',
  'ux.hoje.acao.DEFINIR_PROXIMO_PASSO': 'Definir o próximo passo',
  'ux.hoje.acao.RESPONDER_MENSAGEM': 'Responder o cliente',
  'ux.hoje.acao.ACOMPANHAR_PROPOSTA': 'Acompanhar a proposta',
  'ux.hoje.acao.TRABALHAR_PRE_VENDA': 'Retomar na pré-venda',
  'ux.hoje.acao.REVISAR_CONGELAMENTO': 'Revisar o congelamento',
  'ux.hoje.acao.REVISAR_FECHAMENTO': 'Revisar a previsão',
  'ux.hoje.entidade.ATIVIDADE': 'Atividade',
  'ux.hoje.entidade.OPORTUNIDADE': 'Negócio',
  'ux.hoje.entidade.PRE_VENDA': 'Pré-venda',
  'ux.hoje.entidade.MENSAGEM': 'Conversa',
  'ux.hoje.entidade.PROPOSTA': 'Proposta',
  'ux.hoje.fonte.ATIVIDADES': 'atividades',
  'ux.hoje.fonte.NEGOCIOS': 'negócios',
  'ux.hoje.fonte.PROPOSTAS': 'propostas',
  'ux.hoje.fonte.MENSAGENS': 'mensagens',
  'ux.hoje.fonte.PRE_VENDAS': 'pré-vendas',

  // Pré-vendas e trilho de processo
  'ux.trilho.atual': 'etapa atual',
  'ux.trilho.anterior': 'etapa anterior',
  'ux.trilho.pendente': 'etapa seguinte',
  'ux.trilho.bloqueada': 'etapa bloqueada',
  'ux.trilho.etapa': 'Etapa',
  'ux.trilho.de': 'de',
  'ux.pv.nestaEtapa': 'Nesta etapa',
  'ux.pv.maisAntiga': 'Mais antiga',
  'ux.pv.atrasadas': 'Ações atrasadas',
  'ux.pv.passagem': 'Passagem (90 dias)',
  'ux.pv.semDados': 'sem dados',
  'ux.pv.efeito': 'Efeito da decisão:',
  'ux.pv.efeitoSegue': 'ao concluir, a empresa segue para',
  'ux.pv.efeitoEntrada': 'a empresa entra na carteira e passa a ser avaliada.',
  'ux.pv.efeitoEntrega':
    'a oportunidade é criada no Comercial — ou a entrega é vinculada a uma oportunidade aberta da empresa, sem duplicar o negócio.',
  'ux.pv.naEtapaHa': 'na etapa há',
  'ux.pv.tentativas': 'tentativas',
  'ux.pv.semInteracao': 'sem interação registrada',
  'ux.pv.ultimaInteracao': 'última interação em',
  'ux.pv.proximaDecisao': 'Próxima decisão:',
  'ux.pv.clienteIdeal': 'Cliente ideal',
  'ux.pv.entrega.jaTemAberta': 'Esta empresa já tem negócio aberto',
  'ux.pv.entrega.escolhaTexto':
    'Para não duplicar o negócio, escolha: entregar a pré-venda a uma oportunidade aberta ou criar um negócio novo de propósito.',
  'ux.pv.entrega.vincularA': 'Entregar em',
  'ux.pv.entrega.jaRecebeu': 'já recebeu outra entrega',
  'ux.pv.entrega.criarNova': 'Criar um negócio novo — é outra venda',
  'ux.pv.entrega.vinculoEfeito':
    'A pré-venda é encerrada como entregue e fica ligada a esta oportunidade. Nada na oportunidade é alterado.',
  'ux.pv.entrega.entregarNoNegocio': 'Entregar nesta oportunidade',
  'ux.pv.entrega.vinculada': 'Pré-venda entregue à oportunidade existente.',

  // Negócios e confirmação
  'ux.confirmacao.rotulo': 'Confirmação',
  'ux.confirmacao.cancelar': 'Cancelar',
  'ux.confirmacao.de': 'De',
  'ux.confirmacao.para': 'Para',
  'ux.neg.titulo': 'Jornada de negócios',
  'ux.neg.subtitulo':
    'O trabalho acontece pelo processo; o Kanban continua como visão de portfólio.',
  'ux.neg.pipeline': 'Pipeline',
  'ux.neg.visoes': 'Visões dos negócios',
  'ux.neg.processo': 'Processo',
  'ux.neg.portfolio': 'Portfólio',
  'ux.neg.lista': 'Lista',
  'ux.neg.fases': 'Fases do negócio',
  'ux.neg.carregando': 'Carregando os negócios',
  'ux.neg.semPipelineTitulo': 'Nenhum pipeline ativo',
  'ux.neg.semPipelineTexto':
    'Os negócios seguem as etapas de um pipeline. Peça a quem administra o CRM para ativar um.',
  'ux.neg.configurarPipelines': 'Configurar pipelines',
  'ux.neg.semEtapa': 'sem etapa configurada',
  'ux.neg.negocios': 'Negócios',
  'ux.neg.valorTotal': 'Valor total',
  'ux.neg.tempoEsperado': 'Tempo esperado',
  'ux.neg.tempoAtual': 'Tempo médio atual',
  'ux.neg.emRisco': 'Em risco',
  'ux.neg.semSla': 'sem SLA',
  'ux.neg.criterioDeSaida': 'Para sair desta fase:',
  'ux.neg.criterioFechamento': 'ganho ou perda, sempre com motivo registrado.',
  'ux.neg.semCriterio': 'nenhuma exigência configurada para a próxima etapa.',
  'ux.neg.configurarCriterio': 'Configurar critérios',
  'ux.neg.faseVaziaTitulo': 'Nenhum negócio aberto nesta fase',
  'ux.neg.faseVaziaTexto':
    'Quando um negócio chegar a esta fase, ele aparece aqui com o que falta para seguir.',
  'ux.neg.faseSemEtapaTexto':
    'Este pipeline não tem etapa nesta fase. Quem administra os pipelines pode associar uma etapa a ela.',
  'ux.neg.faseFechamentoTexto':
    'Ganhos e perdas saem do quadro aberto. Veja os negócios fechados na lista.',
  'ux.neg.verLista': 'Ver a lista de negócios',
  'ux.neg.negociosEm': 'Negócios em',
  'ux.neg.filaDescricao': 'Os que têm mais risco primeiro; depois, os parados há mais tempo.',
  'ux.neg.truncado': 'Parte dos negócios desta fase não coube aqui. A lista completa está no',
  'ux.neg.semRisco': 'Sem risco',
  'ux.neg.risco1': 'risco',
  'ux.neg.riscosN': 'riscos',
  'ux.neg.riscos': 'Riscos',
  'ux.neg.risco.ATIVIDADE_VENCIDA': 'Atividade vencida',
  'ux.neg.risco.ACIMA_DO_SLA': 'Acima do tempo esperado da etapa',
  'ux.neg.risco.SEM_PROXIMO_PASSO': 'Sem próximo passo nem compromisso',
  'ux.neg.risco.PASSO_VENCIDO': 'Próximo passo vencido',
  'ux.neg.risco.FECHAMENTO_VENCIDO': 'Previsão de fechamento vencida',
  'ux.neg.semProximoPasso': 'Sem próximo passo definido',
  'ux.neg.etapaAtual': 'Etapa',
  'ux.neg.probabilidade': 'Probabilidade',
  'ux.neg.previsao': 'Previsão de fechamento',
  'ux.neg.paraAvancar': 'Para avançar para',
  'ux.neg.falta': 'falta:',
  'ux.neg.completarNaFicha': 'Completar na ficha do negócio',
  'ux.neg.avancarPara': 'Avançar para',
  'ux.neg.confirmarAvanco': 'Confirmar e avançar',
  'ux.neg.ultimaEtapa': 'Última etapa aberta: o próximo passo é registrar ganho ou perda.',
  'ux.neg.registrarGanho': 'Registrar ganho',
  'ux.neg.registrarPerda': 'Registrar perda',
  'ux.neg.confirmarGanho': 'Confirmar ganho',
  'ux.neg.confirmarPerda': 'Confirmar perda',
  'ux.neg.desfechoTexto': 'O motivo é obrigatório e fica registrado com o negócio.',
  'ux.neg.semEtapaTerminal': 'Este pipeline não tem etapa para este desfecho',
  'ux.neg.motivo': 'Motivo',
  'ux.neg.escolhaMotivo': 'Escolha o motivo',
  'ux.neg.observacao': 'Observação (opcional)',
  'ux.neg.congelar': 'Congelar negócio',
  'ux.neg.abrirFicha': 'Abrir a ficha completa',
  'ux.neg.feitoAvanco': 'Negócio movido para',
  'ux.neg.feitoGanho': 'Ganho registrado.',
  'ux.neg.feitoPerda': 'Perda registrada.',
  'ux.neg.feitoCongelamento': 'Negócio congelado.',
  'ux.neg.fase.ENTRADA': 'Entrada',
  'ux.neg.fase.DIAGNOSTICO': 'Diagnóstico',
  'ux.neg.fase.SOLUCAO': 'Solução',
  'ux.neg.fase.PROPOSTA': 'Proposta',
  'ux.neg.fase.NEGOCIACAO': 'Negociação',
  'ux.neg.fase.FECHAMENTO': 'Fechamento',
  'ux.neg.verbo.ENTRADA': 'Aceitar',
  'ux.neg.verbo.DIAGNOSTICO': 'Entender',
  'ux.neg.verbo.SOLUCAO': 'Desenhar',
  'ux.neg.verbo.PROPOSTA': 'Formalizar',
  'ux.neg.verbo.NEGOCIACAO': 'Decidir',
  'ux.neg.verbo.FECHAMENTO': 'Ganhar ou perder',
  'ux.neg.objetivo.ENTRADA':
    'Aceitar o negócio: confirmar que há uma oportunidade real, com responsável e próximo passo.',
  'ux.neg.objetivo.DIAGNOSTICO':
    'Entender a necessidade, quem decide e o impacto — com evidência, não com suposição.',
  'ux.neg.objetivo.SOLUCAO':
    'Desenhar a solução que responde ao diagnóstico, com escopo e esforço.',
  'ux.neg.objetivo.PROPOSTA': 'Formalizar a proposta: valor, condições e validade registrados.',
  'ux.neg.objetivo.NEGOCIACAO': 'Conduzir a decisão: objeções, ajustes e aprovação.',
  'ux.neg.objetivo.FECHAMENTO': 'Registrar o desfecho — ganho ou perda — com o motivo.',
  'ux.neg.req.estimated_value': 'Valor estimado',
  'ux.neg.req.expected_close_date': 'Previsão de fechamento',
  'ux.neg.req.probability': 'Probabilidade',
  'ux.neg.req.next_step': 'Próximo passo',
  'ux.neg.req.next_step_due_at': 'Data do próximo passo',
  'ux.neg.req.outcome_reason': 'Motivo de ganho/perda',
  'ux.neg.req.opportunity_type_other': 'Descrição do tipo de negócio',
  'ux.neg.req.contact': 'Ao menos um contato',
  'ux.neg.req.primary_contact': 'Contato principal definido',
  'ux.neg.req.offering': 'Produto/serviço de interesse',
  'ux.neg.req.completed_activity': 'Atividade concluída',
  'ux.neg.req.planned_activity': 'Próximo compromisso agendado',
  'ux.neg.artefato.titulo': 'Documentos e reuniões do negócio',
  'ux.neg.artefato.propostas': 'Propostas',
  'ux.neg.artefato.contratos': 'Contratos',
  'ux.neg.artefato.contrato': 'Contrato',
  'ux.neg.artefato.reunioes': 'Reuniões',
  'ux.neg.artefato.atividades': 'Próximas atividades',
  'ux.neg.artefato.vencida': 'vencida',
  'ux.neg.artefato.nenhum': 'Nenhum registro ainda.',
  'ux.neg.artefato.erro': 'Não foi possível carregar agora.',
  'ux.neg.config.fase': 'Fase da jornada',
  'ux.neg.config.faseAutomatica': 'Automática:',
  'ux.neg.config.criterioDeSaida': 'Critério de saída (texto para a equipe)',
  'ux.neg.config.criterioDeSaidaExemplo': 'Ex.: o cliente confirmou orçamento e prazo',

  // Relacionamentos
  'ux.rel.titulo': 'Relacionamentos',
  'ux.rel.subtitulo': 'Empresas e pessoas com histórico, saúde e próxima ação no mesmo lugar.',
  'ux.rel.listaCompleta': 'Lista completa de empresas',
  'ux.rel.verPessoas': 'Ver pessoas',
  'ux.rel.novaEmpresa': 'Nova empresa',
  'ux.rel.filtros': 'Filtros de relacionamentos',
  'ux.rel.buscar': 'Buscar',
  'ux.rel.buscarExemplo': 'Nome, CNPJ ou domínio',
  'ux.rel.classificacao': 'Classificação',
  'ux.rel.todas': 'Todas',
  'ux.rel.recorte': 'Recorte da carteira',
  'ux.rel.recorteTodas': 'Todas',
  'ux.rel.recorteMinha': 'Minha carteira',
  'ux.rel.recorteSemAcao': 'Sem próxima ação',
  'ux.rel.carregando': 'Carregando os relacionamentos',
  'ux.rel.vazioTitulo': 'Nenhuma empresa por aqui',
  'ux.rel.vazioTexto': 'Cadastre a primeira empresa ou importe a sua base para começar.',
  'ux.rel.vazioComFiltro': 'Nenhuma empresa com esses filtros no que você pode ver.',
  'ux.rel.empresas': 'Empresas',
  'ux.rel.de': 'de',
  'ux.rel.abrirFicha': 'Abrir a ficha completa',
  'ux.rel.saude': 'Saúde do relacionamento',
  'ux.rel.saudeSemAvaliacao': 'ainda sem avaliação no Customer Success.',
  'ux.rel.avaliadaEm': 'Avaliada em',
  'ux.rel.risco.BAIXO': 'Saudável',
  'ux.rel.risco.MEDIO': 'Atenção',
  'ux.rel.risco.ALTO': 'Em risco',
  'ux.rel.risco.DESCONHECIDO': 'Sem dados suficientes',
  'ux.rel.proximaMelhorAcao': 'Próxima melhor ação',
  'ux.rel.semProximaAcao': 'Sem próxima ação definida',
  'ux.rel.ultimaInteracao': 'Última interação',
  'ux.rel.nenhumaInteracao': 'nenhuma registrada',
  'ux.rel.negociosAbertos': 'Negócios abertos',
  'ux.rel.negocios': 'Negócios',
  'ux.rel.pessoas': 'Pessoas',
  'ux.rel.principal': 'principal',
  'ux.rel.historico': 'Linha do tempo',
  'ux.rel.carregandoHistorico': 'Carregando o histórico',
  'ux.rel.historicoVazio': 'Nenhum evento registrado ainda.',
  'ux.rel.fonte.CADASTRO': 'Cadastro',
  'ux.rel.fonte.CONTATOS': 'Pessoas',
  'ux.rel.fonte.NEGOCIOS': 'Negócios',
  'ux.rel.fonte.ATIVIDADES': 'Atividades',
  'ux.rel.fonte.RESERVAS': 'Reservas',
  'ux.rel.fonte.COMUNICACOES': 'Mensagens',
  'ux.rel.fonte.REUNIOES': 'Reuniões',
  'ux.rel.fonte.PROPOSTAS': 'Propostas',
  'ux.rel.fonte.PRE_VENDAS': 'Pré-vendas',

  // Conversas e CERES pelo WhatsApp
  'ux.conv.titulo': 'Conversas',
  'ux.conv.subtitulo':
    'Cliente, empresa, negócio e próximo passo no mesmo lugar — e o CRM operado pelo WhatsApp.',
  'ux.conv.experiencias': 'Experiências de conversa',
  'ux.conv.comClientes': 'Com clientes',
  'ux.conv.comOCeres': 'Com o CERES',
  'ux.conv.semAcessoTitulo': 'Nenhuma conversa disponível para o seu perfil',
  'ux.conv.semAcessoTexto':
    'As conversas com clientes exigem acesso às comunicações; a conversa com o CERES exige o canal WhatsApp no plano.',
  'ux.conv.filtro': 'Filtro de conversas',
  'ux.conv.filtro.TODAS': 'Todas',
  'ux.conv.filtro.AGUARDANDO_RESPOSTA': 'Aguardando resposta',
  'ux.conv.filtro.SEM_VINCULO': 'Sem vínculo',
  'ux.conv.buscar': 'Buscar pessoa ou empresa',
  'ux.conv.semVinculoTexto':
    'Mensagens de quem o CRM ainda não reconheceu. Identifique a pessoa (ou descarte) — nada é associado sozinho.',
  'ux.conv.carregando': 'Carregando as conversas',
  'ux.conv.carregandoConversa': 'Carregando a conversa',
  'ux.conv.vazioTitulo': 'Nenhuma conversa nos últimos 90 dias',
  'ux.conv.vazioTexto':
    'Quando uma pessoa escrever ou receber uma mensagem pelo CRM, a conversa aparece aqui, com o contexto comercial.',
  'ux.conv.vazioAguardando': 'Ninguém está esperando resposta.',
  'ux.conv.lista': 'Conversas',
  'ux.conv.aguardando': 'Aguardando resposta',
  'ux.conv.vinculoAConfirmar': 'Negócio a confirmar',
  'ux.conv.voltarParaLista': 'Voltar para a lista',
  'ux.conv.mensagens': 'Mensagens da conversa',
  'ux.conv.semMensagens': 'Nenhuma mensagem registrada com esta pessoa.',
  'ux.conv.reuniao': 'Reunião',
  'ux.conv.responder': 'Responder',
  'ux.conv.canal': 'Canal',
  'ux.conv.canal.EMAIL': 'E-mail',
  'ux.conv.canal.WHATSAPP': 'WhatsApp',
  'ux.conv.canal.SMS': 'SMS',
  'ux.conv.canal.REUNIAO_ONLINE': 'Reunião online',
  'ux.conv.canal.PRESENCIAL': 'Presencial',
  'ux.conv.canal.LIGACAO': 'Ligação',
  'ux.conv.canal.NOTA': 'Nota',
  'ux.conv.finalidade': 'Finalidade',
  'ux.conv.finalidade.RELACIONAMENTO': 'Relacionamento',
  'ux.conv.finalidade.TRANSACIONAL': 'Transacional',
  'ux.conv.finalidade.PROSPECCAO': 'Prospecção',
  'ux.conv.negocioDaMensagem': 'Negócio desta mensagem',
  'ux.conv.escolhaNegocio': 'Escolha o negócio',
  'ux.conv.deNenhumNegocio': 'De nenhum negócio',
  'ux.conv.ambiguoTexto':
    'A empresa tem mais de um negócio aberto: diga a qual esta mensagem se refere.',
  'ux.conv.registradoTexto':
    'No CERES, WhatsApp e SMS para clientes ficam registrados na conversa — o envio é feito pelo seu aparelho. Só o e-mail sai pelo CRM.',
  'ux.conv.assunto': 'Assunto',
  'ux.conv.mensagem': 'Mensagem',
  'ux.conv.escrevaPlaceholder': 'Escreva a mensagem',
  'ux.conv.enviar': 'Enviar',
  'ux.conv.registrar': 'Registrar',
  'ux.conv.mensagemFicou': 'Mensagem',
  'ux.conv.situacao.SCHEDULED': 'agendada',
  'ux.conv.situacao.BLOCKED': 'bloqueada pela política de contato',
  'ux.conv.situacao.REGISTERED': 'registrada',
  'ux.conv.situacao.SENT': 'enviada',
  'ux.conv.situacao.DELIVERED': 'entregue',
  'ux.conv.situacao.FAILED': 'com falha no envio',
  'ux.conv.situacao.CANCELLED': 'cancelada',
  'ux.conv.contexto': 'Contexto comercial',
  'ux.conv.vinculoAmbiguo': 'mais de um negócio aberto — escolha a cada mensagem',
  'ux.conv.semNegocio': 'nenhum negócio aberto',
  'ux.conv.negociosDaEmpresa': 'Negócios abertos da empresa',
  'ux.conv.criarFollowUp': 'Criar follow-up',
  'ux.conv.followUpAssunto': 'O que fazer',
  'ux.conv.followUpSemNegocio':
    'Com mais de um negócio aberto, o follow-up fica na pessoa e na empresa, sem negócio.',
  'ux.conv.followUpCriado': 'Follow-up criado.',
  'ux.conv.verLinhaDoTempo': 'Ver a linha do tempo da empresa',
  'ux.ceres.rotulo': 'CERES pelo WhatsApp',
  'ux.ceres.titulo': 'Seu CRM sem precisar abrir o CRM',
  'ux.ceres.texto':
    'Consulte e atualize o CERES por mensagem. Toda alteração mostra um resumo e só acontece depois de CONFIRMAR.',
  'ux.ceres.carregando': 'Carregando o que o canal faz',
  'ux.ceres.naoContratado':
    'O canal WhatsApp não está no plano desta organização. A lista abaixo mostra o que ele faria.',
  'ux.ceres.consultas': 'Consultar',
  'ux.ceres.acoes': 'Alterar, sempre com confirmação',
  'ux.ceres.acoesTexto': 'A prévia vale por',
  'ux.ceres.desfazerTexto': 'dá para desfazer em até',
  'ux.ceres.limiteTexto': 'até esta quantidade de alterações por hora:',
  'ux.ceres.minutos': 'minutos',
  'ux.ceres.recusas': 'O que o canal não faz, de propósito',
  'ux.ceres.recusasTexto': 'Estes pedidos são recusados pelo WhatsApp; use a tela do CRM.',
  'ux.ceres.comoFunciona': 'Como uma alteração acontece',
  'ux.ceres.passo.identificar': 'O CERES identifica você pelo número vinculado.',
  'ux.ceres.passo.organizacao': 'Confere a organização ativa do número.',
  'ux.ceres.passo.permissao': 'Valida a sua permissão para aquele tipo de alteração.',
  'ux.ceres.passo.entender': 'Entende o pedido.',
  'ux.ceres.passo.resolver': 'Resolve empresa, negócio e data — e pergunta quando há dúvida.',
  'ux.ceres.passo.previa': 'Mostra a prévia do que vai mudar.',
  'ux.ceres.passo.confirmar': 'Espera você responder CONFIRMAR.',
  'ux.ceres.passo.executar': 'Executa uma única vez (mensagem repetida não duplica).',
  'ux.ceres.passo.auditar': 'Registra na auditoria.',
  'ux.ceres.passo.responder': 'Responde com o resultado e o próximo passo.',
  'ux.ceres.liberada': 'Disponível para você',
  'ux.ceres.foraDoPerfil': 'Fora do seu perfil',
  'ux.ceres.soPelaIa': 'Disponível quando a interpretação por IA está liberada para você.',
  'ux.ceres.meuNumero': 'Meu número no WhatsApp',
  'ux.ceres.historico': 'O que eu fiz pelo WhatsApp',
  'ux.ceres.carregandoHistorico': 'Carregando o histórico',
  'ux.ceres.historicoVazio': 'Nenhuma alteração pedida pelo WhatsApp nesta organização.',
  'ux.ceres.desfeita': 'desfeita',
  'ux.ceres.consulta.CONSULTAR_EMPRESA_POR_NOME': 'Buscar empresa pelo nome',
  'ux.ceres.consulta.CONSULTAR_EMPRESA_POR_CNPJ': 'Buscar empresa pelo CNPJ',
  'ux.ceres.consulta.EMPRESA_ATUAL': 'Saber de qual empresa a conversa está falando',
  'ux.ceres.consulta.RESUMIR_EMPRESA': 'Resumo da empresa',
  'ux.ceres.consulta.LISTAR_CONTATOS': 'Contatos e decisores da empresa',
  'ux.ceres.consulta.LISTAR_OPORTUNIDADES': 'Oportunidades (abertas, minhas, atrasadas, paradas…)',
  'ux.ceres.consulta.LISTAR_ATIVIDADES': 'Atividades de hoje, amanhã, da semana ou vencidas',
  'ux.ceres.consulta.PROXIMA_ATIVIDADE': 'Próxima atividade',
  'ux.ceres.consulta.DETALHAR_OPORTUNIDADE': 'Detalhes de uma oportunidade',
  'ux.ceres.consulta.RESUMIR_PIPELINE': 'Resumo do pipeline',
  'ux.ceres.acao.CRIAR_ATIVIDADE': 'Criar atividade ou follow-up',
  'ux.ceres.acao.CONCLUIR_ATIVIDADE': 'Concluir atividade',
  'ux.ceres.acao.REAGENDAR_ATIVIDADE': 'Reagendar atividade',
  'ux.ceres.acao.REGISTRAR_NOTA': 'Registrar nota (interação ou resultado de contato)',
  'ux.ceres.acao.ALTERAR_OPORTUNIDADE':
    'Alterar etapa, valor, previsão ou responsável da oportunidade',
  'ux.ceres.acao.DESFAZER': 'Desfazer a última alteração',
  'ux.ceres.exemplo.CONSULTAR_EMPRESA_POR_NOME': 'buscar empresa BugKillers',
  'ux.ceres.exemplo.CONSULTAR_EMPRESA_POR_CNPJ': 'CNPJ 00.000.000/0001-00',
  'ux.ceres.exemplo.EMPRESA_ATUAL': 'qual empresa?',
  'ux.ceres.exemplo.RESUMIR_EMPRESA': 'resumo',
  'ux.ceres.exemplo.LISTAR_CONTATOS': 'contatos da BugKillers',
  'ux.ceres.exemplo.LISTAR_OPORTUNIDADES': 'oportunidades abertas',
  'ux.ceres.exemplo.LISTAR_ATIVIDADES': 'atividades de hoje',
  'ux.ceres.exemplo.PROXIMA_ATIVIDADE': 'próxima atividade',
  'ux.ceres.exemplo.DETALHAR_OPORTUNIDADE': 'como está a oportunidade X?',
  'ux.ceres.exemplo.RESUMIR_PIPELINE': 'resumo do pipeline',
  'ux.ceres.exemplo.CRIAR_ATIVIDADE': 'crie uma tarefa para ligar para a BugKillers amanhã às 10h',
  'ux.ceres.exemplo.CONCLUIR_ATIVIDADE': 'concluir minha próxima atividade',
  'ux.ceres.exemplo.REAGENDAR_ATIVIDADE':
    'reagende a próxima atividade da BugKillers para sexta às 15h',
  'ux.ceres.exemplo.REGISTRAR_NOTA': 'adicione uma nota na BugKillers: cliente pediu retorno',
  'ux.ceres.exemplo.ALTERAR_OPORTUNIDADE': 'mova a oportunidade X para proposta',
  'ux.ceres.recusa.EXCLUSAO': 'Excluir registros',
  'ux.ceres.recusa.MASSA': 'Alterar em massa',
  'ux.ceres.recusa.USUARIOS_E_ACESSOS': 'Usuários e acessos',
  'ux.ceres.recusa.CONFIGURACAO': 'Configuração',
  'ux.ceres.recusa.IMPORTACAO_EXPORTACAO': 'Importar ou exportar',
  'ux.ceres.recusa.MENSAGEM_A_CLIENTE': 'Enviar mensagem a cliente',
  'ux.ceres.recusa.DOCUMENTO': 'Documentos',
  'ux.ceres.recusa.FINANCEIRO': 'Financeiro',
  'ux.ceres.recusa.GANHO_OU_PERDA': 'Registrar ganho ou perda',
  'ux.ceres.recusa.CRIAR_EMPRESA': 'Cadastrar empresa',
  'ux.ceres.recusa.CRIAR_OPORTUNIDADE': 'Criar oportunidade',
  'ux.ceres.recusa.CRIAR_CONTATO': 'Cadastrar contato',
  'ux.ceres.recusa.TROCA_DE_PIPELINE': 'Trocar de pipeline',
  'ux.ceres.situacao.DRAFT': 'em preparação',
  'ux.ceres.situacao.PENDING_CONFIRMATION': 'aguardando CONFIRMAR',
  'ux.ceres.situacao.EXECUTING': 'em execução',
  'ux.ceres.situacao.EXECUTED': 'feita',
  'ux.ceres.situacao.CANCELLED': 'cancelada',
  'ux.ceres.situacao.EXPIRED': 'expirou sem confirmação',
  'ux.ceres.situacao.REJECTED': 'recusada',
  'ux.ceres.situacao.FAILED': 'não concluída',
  // CERES-PRE-002-003 — contadores, universo e linguagem única da pré-venda
  'ux.pv.carteira.emAndamento': 'pré-vendas em andamento',
  'ux.pv.preVenda': 'pré-venda',
  'ux.pv.preVendas': 'pré-vendas',
  'ux.pv.comFiltros': 'com os filtros aplicados',
  'ux.pv.situacao.rotulo': 'Situação',
  'ux.pv.situacao.andamento': 'Em andamento',
  'ux.pv.situacao.nutricao': 'Em nutrição',
  'ux.pv.situacao.encerradas': 'Encerradas',
  'ux.pv.situacao.todas': 'Todas',
  'ux.pv.status.EM_NUTRICAO': 'Em nutrição',
  'ux.pv.status.DESCARTADO': 'Encerrada · descartada',
  'ux.pv.status.CONVERTIDO': 'Encerrada · enviada ao Comercial',
  'ux.pv.semDecisaoEncerrada': 'Nenhuma — encerrada',
  'ux.pv.semDecisaoNutricao': 'Aguardar a retomada',
  'ux.pv.estado.trabalho.SUSPECT': 'Avaliar aderência',
  'ux.pv.estado.trabalho.PROSPECT': 'Fazer abordagem',
  'ux.pv.estado.trabalho.OUTREACH': 'Confirmar interesse',
  'ux.pv.estado.trabalho.ENGAGED': 'Qualificar necessidade',
  'ux.pv.estado.trabalho.LEAD': 'Concluir qualificação',
  'ux.pv.estado.trabalho.QUALIFIED': 'Entregar ao Comercial',
  'ux.pv.estado.decisao.SUSPECT': 'Aprovar, nutrir ou descartar',
  'ux.pv.estado.decisao.PROSPECT': 'Registrar a primeira tentativa de contato',
  'ux.pv.estado.decisao.OUTREACH': 'Houve conversa? Sem resposta, continua em contato',
  'ux.pv.estado.decisao.ENGAGED': 'Iniciar a qualificação',
  'ux.pv.estado.decisao.LEAD': 'Aprovar ou não a qualificação',
  'ux.pv.estado.decisao.QUALIFIED': 'Criar ou vincular a oportunidade',
  'ux.pv.estado.destino.QUALIFIED': 'Oportunidade criada ou vinculada',
  'ux.pv.estadoAtual': 'Estado atual',
  'ux.pv.trabalhoAgora': 'Trabalho agora',
  'ux.pv.proximaDecisaoRotulo': 'Próxima decisão',
  'ux.pv.destinoPrincipal': 'Destino principal',
  'ux.pv.proximoEstado': 'Próximo estado',
  'ux.pv.criterios': 'Critérios',
  'ux.pv.objetivoOuServico': 'Objetivo ou serviço',
  'ux.pv.segueParaEstado': 'Segue para',
  'ux.pv.preVendasDaEmpresa': 'pré-vendas desta empresa',
  'ux.pv.abertaEm': 'aberta em',
  'ux.pv.foraDaOperacao': 'Fora da operação',
  'ux.pv.foraDaOperacaoTexto': 'Histórico: não são trabalho pendente e não entram nos contadores.',
  'ux.pv.nutricaoRetomadaEm': 'retomada em',
  'ux.pv.proc.primeiraTentativa': 'Primeira tentativa registrada',
  'ux.pv.proc.semResposta': 'Não atendeu ou sem resposta',
  'ux.pv.proc.semRespostaTexto': 'A tentativa fica registrada e a pré-venda continua em contato.',
  'ux.pv.proc.qualificacaoAprovada': 'Qualificação aprovada',
  'ux.pv.proc.naoAprovada': 'Qualificação não aprovada',
  'ux.pv.proc.naoAprovadaTexto': 'Continua em qualificação até completar, nutrir ou descartar.',
  'ux.pv.proc.entregue': 'Oportunidade criada ou vinculada',
  'ux.pv.proc.acao.abordar': 'Abordar próxima empresa',
  'ux.pv.proc.agir.abordar': 'Abordar',
  'ux.pv.proc.acao.contato': 'Registrar contato',
  'ux.pv.proc.agir.contato': 'Registrar',
  'ux.pv.proc.contatoA3': 'Confirmar o que foi dito',
  'ux.pv.proc.contatoA3Texto':
    'Só conversa conta: respondeu, atendeu, aceitou reunião ou pediu retorno.',
  'ux.pv.aviso.para': 'para',
  'ux.pv.aviso.primeiraTentativa':
    'Ao registrar a primeira tentativa, com a próxima ação e a data, esta pré-venda passa de',
  'ux.pv.aviso.soConversa':
    'Só uma conversa (atendeu, respondeu, aceitou reunião ou pediu retorno) leva esta pré-venda de',
  'ux.pv.aviso.tentativaFica': 'Não atendeu e sem resposta ficam registrados como tentativa.',
  'ux.pv.aviso.iniciarQualificacao': 'Ao iniciar a qualificação, esta pré-venda passa de',
  'ux.pv.aviso.concluirQualificacao': 'Se a qualificação for aprovada, esta pré-venda passa de',
  'ux.pv.aviso.naoAprovada': 'Se não for aprovada, continua no mesmo estado.',
  'ux.pv.aviso.generico': 'Ao concluir, esta pré-venda passa de',
  'ux.pv.aviso.semResposta':
    'A tentativa será registrada, mas ainda não representa demonstração de interesse.',
  'ux.pv.resultados.historico':
    'Resultados é o histórico do período: os filtros e os números da Carteira não se aplicam aqui.',
} as const;
